export default __webpack_public_path__ + "static/media/antoine-barres.bc3299c2.jpg";